import { useState } from "react";
import { useSelector } from "react-redux";
import { useGetTemplatesQuery } from "../../../store/api/tasks/taskApiSlice";
import { API } from "../../../globals/globals";
import { localtemplatesColumns, panelTemplatesColumns } from "../../Shared/Table/Columns";
import { selectedTypeSelector } from "../../../store/api/devices/selectors";

export const useDeviceConfigTemplateDisplay = () => {
  const selectedTempType = useSelector(selectedTypeSelector);
  const [selectedTemplateType, setSelectedTemplateType] = useState("");
  const [sortOrder, setSortOrderToLocalTemplate] = useState("");

  const args = {
    filters: sortOrder ? `sort=${sortOrder}` : "",
  };

  const TemplateColumns = localtemplatesColumns(selectedTempType || "");

  const { data, isLoading } = useGetTemplatesQuery(args, {
    pollingInterval: API.ENDPOINTS.TEMPLATES.pollingInterval || API.POLLING_INTERVAL,
  });

  return {
    data,
    isLoading,
    TemplateColumns,
    panelTemplatesColumns,
    //handleApplyTemplate,
    selectedTemplateType,
    setSelectedTemplateType,
    setSortOrderToLocalTemplate,
  };
};
